// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__et0Qi","ddContainer":"styles_ddContainer__5KjJB"};